import {HTTP} from "./common";

export const ExternalApi = {
    list(filter) {
        return HTTP.get(`feedback_reqeust/?${filter ? filter : ""}`).then((response) => {
            return response.data;
        });
    },
    post(id, data) {
        return HTTP.patch(`feedback_reqeust/${id}/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            return response.data;
        });
    }

};
